const stringToArray = (str) => {
    // Choose correct separator
    const sep = str.indexOf(',') > -1 ? ',' : ' ';
    // Turn "rgb(r,g,b)" into [r,g,b]
    return str.substr(4).split(')')[0].split(sep);
};

const toHexidecimal = (c) => (+c).toString(16);

const appendZero = (n) => (n.length == 1 ? `0${n}` : n);

function rgbToHex(r, g, b) {
    const rgb = !g ? stringToArray(r) : [r, g, b];

    return `#${rgb.map((c) => appendZero(toHexidecimal(c))).join('')}`;
}

export {rgbToHex};
